import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_QR_CODE = defineFcm('psf_promote_or_share_qr_code')
	.asJson(
		z.object({
			enabled: z.boolean().optional(),
			experimentName: z.string().optional(),
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Kill-switch and experiment binding for the QR code tile on the promote_or_share share slide-up (CHANGE-99266). Four arms: control, fake_control, variant_1 (QR tile, Save image), variant_2 (QR tile, Save image and Print poster). Signers are treated when the slide-up opens.',
		template: {
			enabled: false,
			experimentName: 'psf_promote_or_share_qr_code_experiment',
		},
	});
